module.exports = __webpack_public_path__ + "assets/img/1_1014.02b68feb.jpg";